import { searchCommand } from "../../../api/api-hooks/conversations/useUpdateGPTConversations.ts/searchCommand";
import BrieIconOutlined from "../BrieIconOutlined";
import { SearchResponse } from "../GPTConvoTypes";
import { useNavigate } from "react-router-dom";

export default function SearchMessage({
  message,
}: {
  message: SearchResponse;
}) {
  const navigate = useNavigate();

  return (
    <div>
      <BrieMessageHeader title="Search Command" />
      <BrieMessageBody onClick={performSearch} message={message?.Message} />
    </div>
  );

  function performSearch() {
    searchCommand({ message, setQuery: undefined, navigate });
  }
}

export function BrieMessageHeader({ title }: { title: React.ReactNode }) {
  return (
    <div className="d-flex align-items-center font-weight-500 gap-2 border-bottom border-superlight pt-1 pb-1 px-2">
      <div
        className="bg-primary w-fit"
        style={{
          borderRadius: "50%",
          width: "fit-content",
          padding: "1px 6px",
        }}
      >
        <BrieIconOutlined />
      </div>
      <div>{title}</div>
    </div>
  );
}

export function BrieMessageBody({
  onClick,
  message,
}: {
  onClick: () => void;
  message: string;
}) {
  return (
    <div
      onClick={onClick}
      className="d-flex align-items-center justify-content-between cursor-pointer p-2 bg-superlight--hover rounded-bottom"
      style={{ minWidth: 270 }}
    >
      {message}
      <i className="mdi mdi-chevron-right text-xl ml-2"></i>
    </div>
  );
}
